import { defineStore } from 'pinia'
import { get } from 'lodash'
import { randomKey } from '@/utils/state_helpers'

export const useMessagesStore = defineStore('messages', {
  state: () => ({
    messages: {}
  }),

  actions: {
    add({ type, text, persist = false }) {
      this.messages = { ...this.messages, [randomKey()]: { type, text, persist } }
    },

    addAlert(text) {
      this.add({ type: 'alert', text })
    },

    addPersistentAlert(text) {
      this.add({ type: 'alert', text, persist: true })
    },

    addNotice(text) {
      this.add({ type: 'notice', text })
    },

    addSuccess(text) {
      this.add({ type: 'success', text })
    },

    addPersistentSuccess(text) {
      this.add({ type: 'success', text, persist: true })
    },

    addWarning(text) {
      this.add({ type: 'warning', text })
    },

    addPersistentWarning(text) {
      this.add({ type: 'warning', text, persist: true })
    },

    addInfo(text) {
      this.add({ type: 'info', text })
    },

    addError(err) {
      const message = get(
        err,
        'response.data.message',
        get(err, 'message', 'An unknown error occurred')
      )
      this.addAlert(message)
    },

    addFlash(flash) {
      let type

      if (flash.alert) {
        type = 'alert'
      } else if (flash.notice) {
        type = 'notice'
      } else if (flash.info) {
        type = 'info'
      }

      if (type) {
        this.add({ type, text: flash[type] })
      }
    },

    smartAdd(obj) {
      const json = obj.response?.data

      if (json?.flash) {
        this.addFlash(json.flash)
      } else if (json?.message) {
        if (json?.status === 'error') {
          this.addAlert(json.message)
        } else {
          this.addNotice(json.message)
        }
      } else if (obj instanceof Error) {
        this.addAlert(obj.message)
      }
    }
  }
})
